<template>
  <windowSocket class="socket-box" ref="socketRef" @message="onMessage" @open="onConnected">
      <div class="workvision-video-box">
        <div v-if="dataList.length === 0" class="video-box video-box--empty">
          <div class="empty-text">{{ langMap.workVisionNoRobotVideo[lang] }}</div>
        </div>
        <grid ref="gridRef" :tipShow="false" class="grid-ref-box scrollbar-g" :btnStyle="{top:'26px',right:'48%'}" :colHeight="'680px'">
          <template slot-scope="slot">
            <div class="video-box" :bordered="false">
              <div class="play-mode-switch">
                <div class="mode-toggle" @click="togglePlayMode(slot.data.id)" :title="getSwitchPlayModeTitle(slot.data.id)">
                  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
                    <path d="M510.317714 0a510.317714 510.317714 0 1 1 0 1020.635429A510.317714 510.317714 0 0 1 510.317714 0z m273.042286 560.932571H240.786286a44.617143 44.617143 0 1 0 0 89.088h433.883428l-28.233143 28.233143a44.470857 44.470857 0 1 0 62.902858 62.902857l104.228571-104.228571 1.536-1.609143 0.658286-0.731428 0.438857-0.512a9.801143 9.801143 0 0 0 1.170286-1.462858l0.585142-0.658285 0.438858-0.585143 0.438857-0.585143 0.438857-0.731429 0.731428-1.170285c0.073143-0.219429 0.219429-0.438857 0.438858-0.585143l0.658285-1.243429a2.267429 2.267429 0 0 1 0.438857-0.658285c0.219429-0.438857 0.438857-0.731429 0.512-1.170286 0.146286-0.219429 0.219429-0.585143 0.438858-0.731429l0.438857-1.097143 0.438857-1.024 0.292571-0.950857 0.438857-1.097143 0.365715-0.877714c0.073143-0.438857 0.292571-0.877714 0.438857-1.170286 0.073143-0.219429 0.073143-0.585143 0.219428-0.731428l0.292572-1.316572c0.146286-0.219429 0.146286-0.438857 0.146286-0.731428l0.292571-1.389714 0.146286-0.731429a6.363429 6.363429 0 0 0 0.219428-1.462857l0.073143-0.804572c0.146286-0.438857 0.146286-0.877714 0.146286-1.316571l0.073143-1.097143 0.146285-1.097143 0.073143-2.194285-0.073143-2.194286c0-0.292571 0-0.585143-0.146285-1.024v-0.585143l-0.219429-1.828571-0.073143-0.877715c-0.146286-0.438857-0.146286-0.950857-0.219428-1.462857l-0.146286-0.731428-0.292571-1.389715c-0.146286-0.219429-0.146286-0.438857-0.146286-0.658285l-0.292572-1.316572c-0.146286-0.146286-0.146286-0.512-0.219428-0.731428-0.146286-0.438857-0.219429-0.877714-0.438857-1.170286l-0.365715-0.877714-0.438857-1.097143-0.292571-0.950857c-0.073143-0.365714-0.292571-0.731429-0.438857-1.024l-0.438857-1.097143c-0.073143-0.219429-0.219429-0.512-0.438858-0.731429-0.219429-0.438857-0.438857-0.731429-0.512-1.170286a2.267429 2.267429 0 0 0-0.438857-0.731428l-0.731428-1.170286a2.267429 2.267429 0 0 0-0.365715-0.658286l-0.731428-1.170285-0.438857-0.658286c-0.219429-0.438857-0.585143-0.731429-0.877715-1.170286l-0.585142-0.731428-0.731429-0.877715-0.731429-0.877714c-0.292571-0.219429-0.438857-0.585143-0.731428-0.731428l-1.462857-1.682286-1.682286-1.462857-0.731429-0.731429-0.877714-0.731428-0.950857-0.731429c-0.219429-0.292571-0.438857-0.365714-0.731429-0.585143l-0.512-0.438857-0.585142-0.438857-0.731429-0.438857-1.170286-0.731429a2.267429 2.267429 0 0 1-0.658285-0.438857l-1.170286-0.731429c-0.219429 0-0.438857-0.146286-0.658286-0.365714-0.438857-0.219429-0.731429-0.438857-1.170286-0.512-0.219429-0.146286-0.585143-0.219429-0.731428-0.438857l-0.585143-0.292571-1.462857-0.585143-1.024-0.365715-1.097143-0.438857-0.877714-0.292571-1.170286-0.438857c-0.219429-0.146286-0.585143-0.146286-0.731429-0.219429l-1.389714-0.365714-0.731428-0.219429-1.462858-0.292571-0.731428-0.073143a6.363429 6.363429 0 0 0-1.462857-0.219429l-0.731429-0.146285-1.389714-0.073143-1.097143-0.146286-0.950857-0.073143-1.097143-0.073143zM311.222857 279.405714L206.921143 383.707429l-1.462857 1.609142c-0.219429 0.219429-0.438857 0.585143-0.731429 0.731429l-0.731428 0.877714-0.731429 1.024-0.512 0.658286-0.877714 1.170286-0.438857 0.658285c-0.219429 0.438857-0.585143 0.731429-0.731429 1.170286a2.267429 2.267429 0 0 1-0.512 0.731429l-0.658286 1.170285-0.438857 0.658286-0.512 1.170286c-0.073143 0.219429-0.219429 0.512-0.438857 0.731428l-0.438857 1.097143c-0.073143 0.365714-0.292571 0.658286-0.438857 0.950857l-0.292572 1.024-0.438857 1.097143-0.365714 0.877715c-0.073143 0.438857-0.292571 0.804571-0.438857 1.170285-0.073143 0.219429-0.073143 0.512-0.219429 0.731429l-0.292571 1.316571-0.073143 0.731429-0.219429 0.658286-0.219428 1.462857a6.363429 6.363429 0 0 0-0.219429 1.462857l-0.146286 0.804571-0.073142 1.316572-0.146286 1.097143-0.073143 1.097142-0.073143 1.024v4.461715c0 0.365714 0 0.731429 0.146286 1.097143l0.146286 1.316571 0.073142 0.877714c0.146286 0.438857 0.146286 0.950857 0.219429 1.462857l0.146286 0.731429 0.292571 1.389714 0.146286 0.658286 0.292571 1.316571c0.073143 0.219429 0.073143 0.512 0.219429 0.731429l0.438857 1.243429 0.292571 0.804571 0.438858 1.097143 0.365714 1.024 0.877714 2.048c0.073143 0.219429 0.219429 0.512 0.438857 0.731428l0.512 1.243429a2.267429 2.267429 0 0 0 0.438857 0.658286l0.658286 1.170285 0.146286 0.292572 1.024 1.536c0.146286 0.219429 0.365714 0.438857 0.438857 0.731428l0.877714 1.097143 0.512 0.731429c0.219429 0.292571 0.585143 0.585143 0.731429 0.950857 0.292571 0.292571 0.585143 0.512 0.804571 0.877714l0.731429 0.731429 1.462857 1.609143 1.609143 1.536 0.731428 0.658285 0.950858 0.731429c0.292571 0.365714 0.585143 0.585143 0.950857 0.731429l0.658285 0.585142 0.585143 0.438858 0.585143 0.438857c0.219429 0.146286 0.438857 0.365714 0.731429 0.438857l1.097143 0.731428a2.267429 2.267429 0 0 1 0.731428 0.438858l1.170286 0.731428c0.219429 0 0.438857 0.146286 0.658286 0.365714l1.170285 0.585143 0.731429 0.438857 1.097143 0.438858c0.365714 0.073143 0.731429 0.292571 1.024 0.438857l0.950857 0.292571 1.097143 0.438857 0.438857 0.146286 1.609143 0.585143c0.219429 0.146286 0.585143 0.146286 0.731428 0.219428l1.316572 0.365715 0.731428 0.219428 1.462857 0.292572 0.731429 0.146285a6.363429 6.363429 0 0 0 1.462857 0.219429l0.877714 0.073143a5.266286 5.266286 0 0 0 1.316572 0.146286l1.024 0.073142 1.024 0.146286 2.194286 0.073143h541.403428a44.617143 44.617143 0 1 0 0-89.088H345.892571l28.233143-28.306286a44.470857 44.470857 0 1 0-62.902857-62.902857z" fill="currentColor"/>
                  </svg>
                </div>
                <span class="mode-text">{{ getPlayModeLabel(slot.data.id) }}</span>
              </div>

              <!-- 可以通过切换这三个组件来选择播放方式 -->
              <!-- <onTimeVideo :robotId="slot.data.id" :robotNum="dataList.length" :videoPlayUrlPrefix="videoBaseUrl"/> -->
              <!-- <jessibucaVideo :robotId="slot.data.id" :robotNum="dataList.length" :videoPlayUrlPrefix="videoBaseUrl"/> -->
			  <webrtcVideo v-if="getPlayMode(slot.data.id) === 'webrtc'" :robotId="slot.data.id" :iceServers="iceServers" :useStun="true" :cameraInfo="slot.data.cameraInfo || {}"/>
			  <jessibucaVideo v-else :robotId="slot.data.id" :robotNum="dataList.length" :videoPlayUrlPrefix="videoBaseUrl" :cameraInfo="slot.data.cameraInfo || {}"/>
            </div>
          </template>
        </grid>
      </div>
  </windowSocket>
</template>
<script>
import windowSocket from "_c/windowSocket/index.vue";
import grid from "_c/grid/index.vue";
import onTimeVideo from "./subunits/flvVideo.vue";
import jessibucaVideo from "./subunits/jessibucaVideo.vue";
import webrtcVideo from "./subunits/webrtcVideo.vue";
import api from "@/api";
import {checkAndFetchMenuList } from '@/libs/util';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { getSocketUrl } from '@/utils/websocket'
let gridRef = null;

function prodRobotArray(arr, d = {}) {
  const _ids = arr || [];
  const data = _ids.map(v => {
    return { id: parseInt(v), ...d };
  });
  return data;
}

function getIndexById(arr, id) {
  let _ix = -1;
  arr.some((v, i) => {
    if (v.id === id) { _ix = i; return true; }
  });
  return _ix;
}
//改成方法传递language
function initData(language) {
  return {
    isOffline: true,
    tipContent: langMap.robotIsOffline[language],
    cameraInfo: { currentType: '' } // 相机信息
  }
}
// const initData = {
//   isOffline: true,
//   tipContent: '机器人已离线'
// };

export default {
  components: { windowSocket, grid, onTimeVideo, jessibucaVideo, webrtcVideo },
  data() {
    return {
      langMap:langMap,
      videoBaseUrl: '',
      dataList: [],
	  playModeByRobotId: {},
      iceServers: [
        { urls: 'stun:121.41.72.227:13478' },
        {
          urls: 'turn:121.41.72.227:13478',
          username: 'robot',
          credential: '8VuQcmyX'
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
	getPlayMode(robotId) {
	  const key = String(robotId);
	  return this.playModeByRobotId[key] || 'rtmp';
	},
	getPlayModeLabel(robotId) {
	  if (this.getPlayMode(robotId) === 'webrtc') return this.langMap.workVision_playMode_webrtc[this.lang];
	  return this.langMap.workVision_playMode_rtmp[this.lang];
	},
	getSwitchPlayModeTitle(robotId) {
	  const tpl = this.langMap.workVision_switchPlayModeTitleWithCurrent && this.langMap.workVision_switchPlayModeTitleWithCurrent[this.lang];
	  if (tpl) return tpl.replace('{mode}', this.getPlayModeLabel(robotId));
	  return this.langMap.workVision_switchPlayModeTitle ? this.langMap.workVision_switchPlayModeTitle[this.lang] : '';
	},
	onChangePlayMode(robotId, mode) {
	  const key = String(robotId);
	  const next = (mode === 'rtmp' || mode === 'webrtc') ? mode : 'rtmp';
	  this.$set(this.playModeByRobotId, key, next);
	},
	onTogglePlayMode(robotId, val) {
	  this.onChangePlayMode(robotId, val ? 'webrtc' : 'rtmp');
	},
	togglePlayMode(robotId) {
	  const cur = this.getPlayMode(robotId);
	  this.onChangePlayMode(robotId, cur === 'webrtc' ? 'rtmp' : 'webrtc');
	},
    getDic() {
      this.videoBaseUrl = getSocketUrl() +'/live?port=7935&app=live&stream=stream';
    },
    getIceServers() {
      api.getData("system-server/config/list?keys=iceServers").then(r => {
        if (r.state == 0) {
          console.error('获取iceServers配置失败:', r.msg);
        } else {
          let config = r.data['iceServers'];
          if (config && config.configValue) {
            try {
              // 解析JSON配置
              const Config = JSON.parse(config.configValue);
              this.iceServers = Config
            } catch (error) {
              console.error('解析iceServers配置失败:', error);
            }
          }
        }
      }).catch(error => {
        console.error('请求iceServers配置失败:', error);
      });
    },
    getRobots() {

      return api.getData("notice-server/usr/robot/list", this).then(res => {
        if (res.state === 1) {
          this.dataList = prodRobotArray(res.data,initData(this.lang));  ;
          gridRef.refreshList(this.dataList,true);
        }
      });
    },
    onMessage(data) {
      let _dataList = this.dataList;
      const _id = data.robotId;
      let _ix = getIndexById(_dataList, _id);

      switch (data.type) {
        case 'robot_ids':
          const _idarr = data.data || []

          _dataList = prodRobotArray(_idarr, initData(this.lang));
          break;
        case 'offline:':
          let _robotItem = { ..._dataList[_ix], ...initData(this.lang) };
          _robotItem.isOffline = true;
          _robotItem.tipContent = langMap.robotIsOffline[this.lang],
          _dataList.splice(_ix, 1, _robotItem);
          this.$nextTick(() => gridRef.showTip(_ix, 'offline'));
          break;
        case 'online:':
          let _item = { ..._dataList[_ix], ...initData(this.lang) };
          _item.isOffline = false;
          _item.tipContent = langMap.robotIsOnline[this.lang],
          _dataList.splice(_ix, 1, _item);
          this.$nextTick(() => gridRef.showTip(_ix,'online'));
          break;
        case 'cameraSwitchType:':
          // 切换相机视角，只更新数据，不改变视频流
          if (_ix >= 0 && data.data && data.data.cameraSwitchType !== undefined) {
            if (!_dataList[_ix].cameraInfo) {
              _dataList[_ix].cameraInfo = {};
            }
            _dataList[_ix].cameraInfo.currentType = String(data.data.cameraSwitchType);
            _dataList.splice(_ix, 1, _dataList[_ix]);
            console.log('收到相机切换消息，机器人ID:', _id, '切换到视角:', data.data.cameraSwitchType);
          }
          break;
        default:
          //console.warn('未知的类型--', data);
          break;
      }
      this.dataList = _dataList;
      gridRef && gridRef.refreshList(this.dataList,true);
    },
    onConnected() {
      const userStore = this.$store.state.user.userInfo;
      this.$refs.socketRef.send({ type: 'online', robotId: '', data: `${userStore.userId}_video` });
    }
  },
  async mounted() {
    gridRef = this.$refs.gridRef;
    this.getDic();
    this.getIceServers();
    await this.getRobots();
	this.dataList.forEach(r => {
	  const key = String(r.id);
	  if (!this.playModeByRobotId[key]) {
	    this.$set(this.playModeByRobotId, key, 'rtmp');
	  }
	});
    this.$refs.socketRef.init();
    checkAndFetchMenuList(this.$store);

  }
};
</script>
<style scoped lang="less">
.video-box{
  padding: 5px;
  height: 100%;
  min-height: 686px;
  width: 100%;
  box-sizing: border-box;
	position: relative;
  /deep/.ivu-card-body {
    height: 100%;
    padding: 5px;
  }
}

.play-mode-switch{
	position: absolute;
	top: 15px;
	right: 10px;
	z-index: 20;
	display: flex;
	align-items: center;
	gap: 6px;
	background: rgba(0, 0, 0, 0.28);
	border: 1px solid rgba(0, 255, 229, 0.35);
	border-radius: 10px;
	padding: 4px;
	backdrop-filter: blur(6px);
	box-shadow:
	  0 0 12px rgba(0, 255, 229, 0.18),
	  inset 0 0 10px rgba(255, 0, 214, 0.12);

	.mode-toggle{
	  width: 26px;
	  height: 26px;
	  border-radius: 8px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  cursor: pointer;
	  color: rgba(0, 255, 229, 0.95);
	  background: rgba(0, 255, 229, 0.08);
	  border: 1px solid rgba(0, 255, 229, 0.35);
	  transition: transform 0.12s ease, background 0.12s ease;
	
	  &:hover{
	    background: rgba(0, 255, 229, 0.14);
	    transform: translateY(-1px);
	  }
	  &:active{
	    transform: translateY(0);
	  }

	  svg{
	    font-size: 16px;
	  }
	}

	.mode-text{
	  color: rgba(255,255,255,0.92);
	  font-size: 12px;
	  letter-spacing: 0.5px;
	  line-height: 16px;
	  user-select: none;
	  text-shadow: 0 0 10px rgba(0, 255, 229, 0.25);
	}
}

/* avoid covering subunit header time (r-top-time) */
.video-box{
	/deep/ .r-top-time{
	  padding-right: 105px;
	}
}
.video-box--empty{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(54,55,58,0.92);
  z-index: 2;
  .empty-text{
    padding: 18px 24px;
    border-radius: 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.85);
    font-size: 14px;
    letter-spacing: 0.5px;
  }
}
.grid-ref-box{
  min-width: 500px;
  position: relative;
}
.workvision-video-box{
  height: 100%;
  position: relative;
}
</style>
